import { pickFirstImageFromGalleryField } from './pickFirstImageFromGalleryField';

import type { ISbStoryData } from 'storyblok-js-client';
import type {
  ExpertStoryblok,
  PersonStoryblok,
  CustomerStoryblok,
} from '@monoimin/sb-types';

type PersonImages = {
  small: string;
  big: string;
};

const EMPTY_PERSON_IMAGES: PersonImages = {
  small: '',
  big: '',
};

export function pickPersonImages(
  blok:
    | ISbStoryData<ExpertStoryblok | PersonStoryblok | CustomerStoryblok>
    | string
): PersonImages {
  if (typeof blok === 'string' || !blok?.content) {
    return EMPTY_PERSON_IMAGES;
  }

  const { content } = blok;

  const { component } = content;
  if (component === 'expert') {
    // Не безопасно исползовать String(content?.photo?.filename), из сториблока иногда приходит null и все ломается не картинка отображается не placeholder
    return {
      small: content?.photo?.filename || '',
      big: content?.bigPhoto?.filename || '',
    };
  }

  if (component === 'person') {
    const smallImage = pickFirstImageFromGalleryField(content['photo']);

    const bigImage = pickFirstImageFromGalleryField(content['bigPhoto']);

    return {
      small: smallImage?.src || '',
      big: bigImage?.src || '',
    };
  }
  if (component === 'customer') {
    return {
      small: content?.image?.filename || '',
      big: content?.bigImage?.filename || '',
    };
  }

  return EMPTY_PERSON_IMAGES;
}

export default pickPersonImages;
